import { Modal, DataTable, DataTableColumnType } from '../../../../common/_custom';
import { Button } from '../../../../common/_custom';
import {
    OwnerCellRenderer,
    NumberCellRenderer,
    SingleSelectDropdownCellRenderer,
} from '../../../../common/_custom/DataTable/components/CellRenderers';
import styles from './MandateCreationModal.module.scss';
import { useMandateCreationModal } from './useMandateCreationModal';

interface MandateCreationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCreateMandate: (updatedMandateData?: any) => void;
}

const MandateCreationModal = ({ isOpen, onClose, onCreateMandate }: MandateCreationModalProps) => {
    const {
        mandateData,
        mandateColumns,
        loading,
        isFormValid,
        updateCustomFieldStatus,
        updateSingleSelectDropdown,
        updateOwner,
        getStatusDropdownList,
        handleProceed,
    } = useMandateCreationModal({ isOpen, onCreateMandate });

    return (
        <Modal open={isOpen} onClose={onClose} size="flexible" persistent={true}>
            <div className={styles.ModalContainer}>
                <div className={styles.Header}>
                    <h2 className={styles.Heading}>Confirm Lead Details</h2>
                </div>
                <div className={styles.Body}>
                    <div className={styles.Message}>
                        Please confirm the details below. These values will be used going forward in Mandates and Leads.
                    </div>

                    {/* Mandate Columns */}
                    {mandateColumns.length > 0 && (
                        <div className={styles.MandateDetails}>
                            <div className={styles.noHoverTable}>
                                <DataTable
                                    columns={mandateColumns}
                                    rows={[
                                        {
                                            ...mandateData,
                                            rowStyle: {
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                            },
                                        },
                                    ]}
                                    totalRowCount={0}
                                    emptyState={<div></div>}
                                    loading={loading}
                                    horizontal={true}
                                    horizontalStyle={{
                                        width: '100%',
                                    }}
                                    horizontalRowStyle={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                    }}
                                    horizontalLabelStyle={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                        color: '#000000',
                                        fontFamily: 'Gilroy-Bold',
                                        fontSize: '14px',
                                    }}
                                    horizontalValueStyle={{
                                        backgroundColor: 'transparent',
                                        border: 'none',
                                    }}
                                    customCellRenderers={{
                                        [DataTableColumnType.OWNER]: (props) => (
                                            <OwnerCellRenderer
                                                {...props}
                                                dynamicProps={{
                                                    isDisabled: false,
                                                    updateOwner: updateOwner,
                                                }}
                                            />
                                        ),
                                        [DataTableColumnType.NUMBER]: (props) => (
                                            <NumberCellRenderer
                                                {...props}
                                                dynamicProps={{
                                                    isDisabled: false,
                                                    updateCustomFieldStatus: updateCustomFieldStatus,
                                                }}
                                            />
                                        ),
                                        [DataTableColumnType.SINGLE_SELECT_DROPDOWN]: (props) => (
                                            <SingleSelectDropdownCellRenderer
                                                {...props}
                                                dynamicProps={{
                                                    isDisabled: false,
                                                    updateSingleSelectDropdown: updateSingleSelectDropdown,
                                                    getStatusDropdownList,
                                                }}
                                            />
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.Actions}>
                    <Button
                        text="Cancel"
                        variant="secondary"
                        onClick={onClose}
                        style={{ marginRight: '1rem', width: '228px', marginTop: '0' }}
                        disabled={loading}
                    />
                    <Button
                        text="Proceed"
                        variant="primary"
                        onClick={handleProceed}
                        style={{ width: '228px', marginTop: '0' }}
                        disabled={loading || !isFormValid}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default MandateCreationModal;
